<div
  class="toolbox"
  (mousedown)="preventEvent($event)"
  (mouseup)="preventEvent($event)"
>
  <button class="toolbox-btn">
    <svg
      class="toolbox-btn-icon"
      (click)="toolboxActionService.handleZoomClick(ZoomType.ZoomToFit)"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 11.2537C3 10.6705 3.2546 10.1163 3.6971 9.73636L10.2395 4.11874C10.9889 3.47525 12.0959 3.47525 12.8453 4.11874L19.3876 9.73636C19.8301 10.1163 20.0847 10.6705 20.0847 11.2537V19C20.0847 20.1046 19.1893 21 18.0847 21H5C3.89543 21 3 20.1046 3 19V11.2537Z"
        stroke-width="3"
      />
    </svg>
  </button>
  <button
    class="toolbox-btn"
    (mousedown)="toolboxActionService.handleZoomClick(ZoomType.InIncessantly)"
    (mouseup)="toolboxActionService.handleZoomClick(ZoomType.In)"
    (mouseleave)="toolboxActionService.handleZoomClick(ZoomType.In, true)"
  >
    <svg
      class="toolbox-btn-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0085 4V20.8M20.0169 12.4H4"
        stroke-width="4"
        stroke-linecap="round"
      />
    </svg>
  </button>
  <button
    class="toolbox-btn"
    (mousedown)="toolboxActionService.handleZoomClick(ZoomType.OutIncessantly)"
    (mouseup)="toolboxActionService.handleZoomClick(ZoomType.Out)"
    (mouseleave)="toolboxActionService.handleZoomClick(ZoomType.Out, true)"
  >
    <svg
      class="toolbox-btn-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.0169 12H4" stroke-width="4" stroke-linecap="round" />
    </svg>
  </button>
  <button
    class="toolbox-btn"
    (click)="toolboxActionService.handleFullScreenClick()"
  >
    <svg
      class="toolbox-btn-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 8.08595V6C4 4.89543 4.89543 4 6 4H8.16529"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M4 16.2579V18.3438C4 19.4484 4.89543 20.3438 6 20.3438H8.16529"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M20.6611 8.08595V6C20.6611 4.89543 19.7657 4 18.6611 4H16.4958"
        stroke-width="3"
        stroke-linecap="round"
      />
      <path
        d="M20.6611 16.2579V18.3438C20.6611 19.4484 19.7657 20.3438 18.6611 20.3438H16.4958"
        stroke-width="3"
        stroke-linecap="round"
      />
    </svg>
  </button>
</div>
